/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-08-25 14:17:58
 * @LastEditors: linwc
 * @LastEditTime: 2025-08-27 15:13:52
 */
const _lysoraImgStore = {
  ...require('./commonImgStore.js'),
  ...require('./homepageStore.js')
};

export default _lysoraImgStore;
